import { Tabs as ChakraTabs, chakra } from '@chakra-ui/react';
import * as React from 'react';

export interface TabsProps extends ChakraTabs.RootProps {}

export const TabsRoot = React.forwardRef<HTMLDivElement, TabsProps>(
  function TabsRoot(props, ref) {
    const { lazyMount = true, unmountOnExit = true, ...rest } = props;
    return (
      <ChakraTabs.Root
        ref={ ref }
        { ...rest }
        lazyMount={ lazyMount }
        unmountOnExit={ unmountOnExit }
      />
    );
  },
);

export const TabsList = ChakraTabs.List;

export interface TabsTriggerProps extends ChakraTabs.TriggerProps {}

export const TabsTrigger = React.forwardRef<
  HTMLButtonElement,
  TabsTriggerProps
>(function TabsTrigger(props, ref) {
  const { children, ...rest } = props;

  return (
    <ChakraTabs.Trigger
      ref={ ref }
      className="group"
      px={ 4 }
      mx={ 1 }
      py={ 2 }
      borderRadius="md"
      fontWeight="medium"
      color="text.secondary"
      transition="all 0.2s ease"
      _hover={{
        color: { _light: '#365C74', _dark: 'blue.300' },
        bg: { _light: '#EAF0F2', _dark: '#505050' },
      }}
      _focusVisible={{
        boxShadow: 'outline',
      }}
      _disabled={{
        opacity: 0.4,
        cursor: 'not-allowed',
      }}
      _selected={{
        color: { _light: '#365C74', _dark: 'blue.300' },
        bg: { _light: '#DCE7EC', _dark: '#505050' },
        fontWeight: 'bold',
      }}
      { ...rest }
    >
      { children }
    </ChakraTabs.Trigger>
  );
});

export const TabsContent = ChakraTabs.Content;

export interface TabsCounterProps {
  count?: number | null;
}

export const TabsCounter = ({ count }: TabsCounterProps) => {
  const COUNTER_OVERLOAD = 50;

  if (count === undefined || count === null) {
    return null;
  }

  return (
    <chakra.span
      fontSize="sm"
      ml={ 1 }
      px={ 2 }
      py="1px"
      borderRadius="full"
      transition="all 0.2s ease"
      bg="transparent"
      color="text.secondary"
      _groupHover={{
        color: { _light: '#365C74', _dark: 'blue.300' },
      }}
      css={{
        '[data-selected] &': {
          color: { _light: '#365C74', _dark: 'blue.300' },
          bg: { _light: '#DCE7EC', _dark: '#3a3a3a' },
          fontWeight: 'bold',
        },
      }}
      // color={
      //   count > 0
      //     ? "text.secondary"
      //     : { _light: "blackAlpha.400", _dark: "whiteAlpha.400" }
      // }
      // _groupHover={{
      //   color: "inherit",
      // }}
    >
      { count > COUNTER_OVERLOAD ? `${ COUNTER_OVERLOAD }+` : count }
    </chakra.span>
  );
};
